import { SvgIcon } from '@material-ui/core';
import React from 'react';
import IconSource from '@tdcerhverv/parrotfish/dist/icons/Icons/Checkmark.svg';
import { TDCIconProps } from '../../icons/TDCIcon';

export const CheckmarkIcon: React.FC<TDCIconProps> = React.memo((props: TDCIconProps) => (
    <SvgIcon component={IconSource} viewBox="0 0 48 48" {...props} />
));

export default CheckmarkIcon;
